module.exports = __webpack_public_path__ + "img/c7.4e4e6ff3.png";